import type { ActionSource } from "../types";

const STYLES: Record<ActionSource, { bg: string; fg: string; label: string }> = {
  MANUAL: { bg: "hsl(210,16%,93%)", fg: "hsl(215,16%,40%)", label: "Manual" },
  MEETING: { bg: "hsl(210,55%,92%)", fg: "hsl(210,100%,28%)", label: "Meeting" },
  TASK: { bg: "hsl(38,90%,92%)", fg: "hsl(32,90%,38%)", label: "Task" },
};

export function ActionSourceBadge({ source }: { source: ActionSource }) {
  const s = STYLES[source];
  return (
    <span
      className="inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium"
      style={{ background: s.bg, color: s.fg }}
    >
      {s.label}
    </span>
  );
}
